import { z } from 'zod';

export const settingsSchema = z.object({
  chartType: z.enum(['bar', 'line', 'area']),
  mfaPreference: z.boolean(),
  editPageLayout: z.enum(['tabbed', 'unified']),
  providerDashboardSummaryMode: z
    .enum(['pay-period', 'month'])
    .optional()
    .default('pay-period'),
  providerDashboardDateBasis: z
    .enum(['billed-date', 'service-date'])
    .optional()
    .default('billed-date'),
  defaultSiteID: z.string().nullable(),
  fiscalYearEnd: z.number().int().min(1).max(12).optional(),
  persistedVisibleColumns: z
    .record(z.string(), z.boolean())
    .optional()
    .default({}),
  providerClaimColumnLayoutVersion: z.number().int().min(0).optional(),
  persistedColumnOrder: z.array(z.string()).optional().default([]),
  persistedColumnSizing: z
    .record(z.string(), z.number().positive().finite())
    .optional(),
  defaultPayorID: z.guid().nullable().optional().default(null),
});
